import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/parametrizacao`

    return {
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        autocomplete(queryParms = {}) {
            return repository.get(`${baseUrl}/autocomplete?${urlUtil.serialize(queryParms)}`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        lotacoes(queryParms = {}) {
            return repository.get(`${baseUrl}/lotacao?${urlUtil.serialize(queryParms)}`)
        },
    }
}